// extracted by mini-css-extract-plugin
export var numpadContainer = "_gy-1";
export var phoneButton = "_gy-0";